export const AUTH_HELP_TEXT = {
  LOGIN: 'Log in below to proceed with the enrollment process.',
  SIGNUP: 'Create an account to proceed with the enrollment process.',
};
